import { reactive } from 'vue';

export interface DialogOptions {
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
}

export interface DialogState extends Required<DialogOptions> {
    visible: boolean;
    resolver?: (value: boolean) => void;
}

export const dialogState = reactive<DialogState>({
    visible: false,
    title: '',
    message: '',
    confirmText: 'Yes',
    cancelText: 'No',
    resolver: undefined
});
